exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#alinear[data-v-9148b964] {\n  text-align: justify;\n}\n.h2_title[data-v-9148b964] {\n  font-weight: normal;\n}\n", ""]);

// exports
